import { markdownToHtml } from './markdownConverter';

const WHITESPACE = /\s+/gu;
const MAX_LENGTH = 120;

export const commentExcerpt = (content = '') => {
  const holder = document.createElement('div');
  holder.innerHTML = markdownToHtml(content);

  const text = (holder.textContent ?? '').replaceAll(WHITESPACE, ' ').trim();

  return text.length > MAX_LENGTH ? `${text.slice(0, MAX_LENGTH)}…` : text;
};
